<template>
  <v-row style="position: relative;">
    <v-col class="col-auto">
      <v-icon
        large
        class="mx-1"
        :color="color"
      >
        {{ icon }}
      </v-icon>
    </v-col>
    <v-col>
      <slot />
      <v-overlay
        :value="locked"
        :absolute="true"
        :opacity="0.05"
      />
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'SequentialStep',
  components: {},
  props: {
    completed: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon () {
      if (this.completed) { return 'done'; }
      if (this.locked) { return 'lock'; }
      return 'mdi-exclamation-thick';
    },
    color () {
      if (this.completed) { return 'green lighten-2'; }
      if (this.locked) { return 'red lighten-2'; }
      return 'primary';
    }
  }
};
</script>
